




































































import EditionModal from "../../core/Modals/EditionModal.vue";
import { RelanceApi } from "../../api/RelanceApi";

export default {
    name: "BalanceAgeeImportModal",
    components: {
        EditionModal,
    },
    props: {
        showImportModal: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showModal: false,
            file: null,
            RelanceApi: new RelanceApi(),
            importResult: null,
            loading: false,
        };
    },
    watch: {
        showImportModal(newVal) {
            this.showModal = newVal;
            if (newVal) {
                // Reset form when modal is opened
                this.file = null;
                this.importResult = null;
            }
        },
    },
    methods: {
        closeModal() {
            this.showModal = false;
            this.$emit("close-modal");
        },
        handleFileUpload(event) {
            this.file = event.target.files[0];
        },
        importExcel() {
            if (!this.file) {
                this.importResult = {
                    error: "Veuillez sélectionner un fichier",
                };
                return Promise.reject("No file selected");
            }

            this.loading = true;
            this.importResult = null;

            return this.RelanceApi.importExcel(this.file)
                .then((response) => {
                    this.importResult = response.data;
                    return response.data;
                })
                .catch((error) => {
                    /*this.importResult = {
                        error: error.response?.data?.error || "Une erreur est survenue lors de l'import"
                    };
                    return Promise.reject(error);*/
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
